import React from "react";

export default function BS_Glyphicons() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">BS_Glyphicons</h2>
      <p>Route: /icons/bootstrap/glyphicons</p>
    </div>
  );
}
